'use strict';
import {FilterInputModule} from '../components/lists/FilterInput/module';

const angular = require('angular');

module.exports = angular
  .module('app.core-components', [
    require('./android-date-time-pickers').name,
    require('./context-menu').name,
    require('./EditPanels').name,
    require('./entity-placeholder').name,
    require('./file-viewer').name,
    FilterInputModule.name,
    require('./help').name,
    require('./loading-icon').name,
    require('./manage-access').name,
    require('./modals').name,
    require('./popover-select').name,
    require('./popovers').name,
    require('./popup').name,
    require('./selectors').name,
    require('./svg-menu-icons').name,
    require('./toast-messages').name,
    require('./transforming-buttons').name,
  ]);



// WEBPACK FOOTER //
// ./src/js/core-components/index.js